import { Typography } from "@mui/material"
import React, { useState } from "react"
import MessageModal from "../components/MessageModal"
import Box from "@mui/material/Box"
import { useAuth } from "../contexts/AuthContext"

export default function Error({ error }) {
    const { authError } = useAuth()
    const [message, setMessage] = useState(
        authError
            ? {
                  type: "Unable to comply...",
                  text:
                      authError?.message ||
                      authError ||
                      "An unexpected error occurred.",
                  navigateTo: "/",
              }
            : error
              ? {
                    type: "Unable to comply...",
                    text:
                        error?.message ||
                        error ||
                        "An unexpected error occurred.",
                    navigateTo: "/",
                }
              : null,
    )

    return (
        <Box
            sx={{
                minHeight: "80vh",
                width: "100%",
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "40vh",
                }}
            >
                <Typography variant="h4" align="center" color="error">
                    {authError}
                </Typography>
            </Box>
            {message && (
                <MessageModal message={message} setMessage={setMessage} />
            )}
        </Box>
    )
}
